import { useBrand } from '../context/BrandContext';
import { excludeCompanyLevel, isCompanyLevelBrand } from '../utils/brandFilters';

/**
 * Brand context for INVENTORY pages.
 *
 * The synthetic "Company Level" brand carries no inventory data, so it must never be
 * an inventory scope. This wraps useBrand() so that:
 *   - `brands` excludes Company Level (dropdowns never offer it), and
 *   - `selectedBrand` reads as null when the persisted global selection IS Company Level,
 *     so inventory pages fall back to their normal "select a brand" prompt instead of
 *     rendering a blank dropdown while silently querying the (near-empty) synthetic brand.
 *
 * The GLOBAL selection is NOT mutated — other areas (e.g. company-level financial reports,
 * connector setup) may legitimately keep Company Level selected. This only changes what
 * inventory pages see.
 *
 * NOTE: pages that handle Company Level specially (StockLevels / InventoryDashboard map it
 * to their "All Brands" consolidated view) intentionally use useBrand() directly, not this.
 */
export function useInventoryBrand() {
  const ctx = useBrand();
  const selectedBrand = isCompanyLevelBrand(ctx.selectedBrand) ? null : ctx.selectedBrand;
  return { ...ctx, brands: excludeCompanyLevel(ctx.brands), selectedBrand };
}
